import { activitiesApi } from 'entities/activities';

type ActivityType = {
  id: number;
  name: string;
  description: string;
};
type ActivityTypeListType = {
  items: ActivityType[];
  total: number;
  page: number;
  size: number;
};

const getActivityTypesApi = activitiesApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivityTypes: builder.query<ActivityTypeListType, any>({
      query: () => '/promo-b2b/admin/promo-b2b/admin/activity-types/?page=1&size=50',
    }),
  }),
});

export const { useGetActivityTypesQuery } = getActivityTypesApi;
